import { render } from "./RichTextRender.vue?vue&type=template&id=5bc21380"
import script from "./RichTextRender.vue?vue&type=script&lang=ts"
export * from "./RichTextRender.vue?vue&type=script&lang=ts"

import "./RichTextRender.vue?vue&type=style&index=0&id=5bc21380&lang=postcss"
script.render = render

export default script